import type { ElementType, Ref } from "react";
import { forwardRef } from "react";
import type { ClayProps } from "../../utilities";
import { Clay } from "../../utilities";

export const _VisualModalVisual = <Element extends ElementType>(
  { children, ...restClayProps }: ClayProps<Element>,
  ref: Ref<HTMLElement>,
) => {
  return (
    <Clay width="100%" height="300px" ref={ref} {...restClayProps}>
      {children}
    </Clay>
  );
};

export const VisualModalVisual = forwardRef(_VisualModalVisual);

VisualModalVisual.displayName = "VisualModalVisual";
